/**
 * ClientLayout.js — Wrapper léger v3.9 (refactor PROMPT CHIRURGICAL)
 * Source unique : components/Layout/AppLayout.js
 */
import React from 'react';
import { Outlet } from 'react-router-dom';
import AppLayout from '../Layout/AppLayout';
import { CLIENT_NAV } from '../../config/roleNavigation';

const ClientLayout = ({ children }) => (
  <AppLayout navItems={CLIENT_NAV}>{children ?? <Outlet />}</AppLayout>
);

export default ClientLayout;